import React from "react";
import "./Contato.css";

// Import dos ícones
import iconLocalizacao from "../../assets/img/localizacao.svg";
import iconWhatsapp from "../../assets/img/whatsapp.svg";
import iconEmail from "../../assets/img/email.svg";

export default function SecaoContato() {
  return (
    <section className="contato-wrapper py-5" id="contato">
  <div className="container contato">
    <div className="row align-items-start">
      {/* Texto de contato */}
      <div className="col-12 col-lg-6 mb-4 mb-lg-0 scroll-reveal-zoom">
        <h2 className="titulo-secao">
          Entre em Contato
          <span className="barra"></span>
        </h2>
        <p className="mb-4">
          Pronto para começar seu projeto? Entre em contato com nossa equipe
          para uma consulta sobre soluções ambientais personalizadas para suas necessidades.
        </p>

        <div className="info-contato">
          <div className="info-item d-flex align-items-start mb-3 scroll-reveal-zoom">
            <img src={iconLocalizacao} alt="Localização" className="icone-contato me-3" />
            <p>
              <strong>Localização:</strong><br />
              Av. Pres. Costa e Silva, 1771 - sala 303 - São Pedro,<br />
              Juiz de Fora - MG, 36037-000
            </p>
          </div>

          <div className="info-item d-flex align-items-start mb-3 scroll-reveal-zoom">
            <img src={iconWhatsapp} alt="WhatsApp" className="icone-contato me-3" />
            <p>
              <strong>WhatsApp:</strong><br />
              <a href="https://wa.me/5532984053160" target="_blank" rel="noopener noreferrer">
                (32) 98405-3160
              </a>
            </p>
          </div>

          <div className="info-item d-flex align-items-start scroll-reveal-zoom">
            <img src={iconEmail} alt="E-mail" className="icone-contato me-3" />
            <p>
              <strong>E-mail:</strong><br />
              <a href="mailto:projeto@ambarmeioambiente.com.br">
                projeto@ambarmeioambiente.com.br
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Mapa */}
      <div className="col-12 col-lg-6 scroll-reveal-glass">
        <div className="mapa-container">
          <iframe
            title="Mapa Âmbar"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3705.198313202551!2d-43.374043099999994!3d-21.7725845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x989b1a47157dd7%3A0xd3fd7fda82371f3c!2s%C3%82mbar%20Solu%C3%A7%C3%B5es%20em%20Engenharia%20e%20Meio%20Ambiente!5e0!3m2!1spt-BR!2sbr!4v1771725699809!5m2!1spt-BR!2sbr"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</section>

  );
}
